export default __webpack_public_path__ + "static/media/1_15_logo.a2d56633.png";